import StatusMessage from '../StatusMessage';
import { StyledBox, StyledTypography } from './styled';

type PropsTypes = {
  url: string;
  status: string;
};

const WhiteListedChannel = ({ url, status }: PropsTypes) => (
  <>
    <StyledBox>
      <StyledTypography>{url}</StyledTypography>
    </StyledBox>
    <StatusMessage status={status} />
  </>
);

export default WhiteListedChannel;
